/**
 * 统一的环境变量读取入口。
 *
 * 业务配置 key 不使用 VITE_ 前缀：
 * - 运行时由 vite.config.ts 的 passthrough-env 插件注入到 __PASSTHROUGH_ENV__ 全局常量。
 * - VITE_ 前缀的变量（VITE_DEV_* / VITE_APP_ENV）仅服务于 vite.config.ts 自身，
 *   不会下发到 import.meta.env。
 *
 * 业务代码统一通过 getEnv(key) 读取，避免在多个文件中重复 import.meta.env 的兼容性包装。
 */

declare const __PASSTHROUGH_ENV__: Record<string, string>

export function getEnv(key: string): string | undefined {
  const passthrough =
    typeof __PASSTHROUGH_ENV__ !== 'undefined' ? __PASSTHROUGH_ENV__ : {}
  if (key in passthrough) return passthrough[key]
  const viteVal = import.meta.env[key as keyof ImportMetaEnv]
  return typeof viteVal === 'string' ? viteVal : undefined
}